<!-- eslint-disable  -->
<template>
  <div class="table-wrapper">
    <div :class="[
      'ag-theme-balham',
      isDark ? 'ag-theme-balham-dark' : '',
      'ag-grid-container'
    ]">
      <ag-grid-vue style="width: 100%; height: 100%;" class="ag-grid" :columnDefs="columnDefs" :rowData="rowData"
        :defaultColDef="{ resizable: true }" :pagination="true" :paginationPageSize="8" :domLayout="'autoHeight'"
        @grid-ready="onGridReady" />
    </div>
  </div>
</template>
<!-- eslint-disable  -->
<script>
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community/dist/styles/ag-theme-balham-dark.css';
import { AgGridVue } from 'ag-grid-vue';
import { mapState } from 'vuex';
function formatDate(value) {
  if (!value) return '';
  const date = new Date(value);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}

export default {
  name: 'MachineCycleTable',
  components: {
    AgGridVue,
  },
  computed: {
    ...mapState('helper', ['isDark']),
    ...mapState('kpiDashboard', ['cycleTimeTabel']),
  },
  data() {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        {
          headerName: 'Machine Name',
          field: 'machinename',
          sortable: true,
          filter: true,
          headerClass: 'ag-header-center',
          cellClass: 'ag-cell-center',
          flex: 1
        },
        {
          headerName: 'Cycle Start',
          field: 'start',
          sortable: true,
          filter: true,
          headerClass: 'ag-header-center',
          cellClass: 'ag-cell-center',
          flex: 1,
          valueFormatter: (params) => formatDate(params.value),
        },
        {
          headerName: 'Cycle End',
          field: 'end',
          sortable: true,
          filter: true,
          headerClass: 'ag-header-center',
          cellClass: 'ag-cell-center',
          flex: 1,
          valueFormatter: (params) => formatDate(params.value),
        },
        {
          headerName: 'Duration (min)',
          field: 'duration',
          sortable: true,
          filter: true,
          headerClass: 'ag-header-center',
          cellClass: 'ag-cell-center',
          flex: 1
        },
      ],
      defaultColDef: {
        resizable: true,
      },
      rowData: [],
    };
  },
  watch: {
    cycleTimeTabel: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal) {
          this.rowData = newVal;
        }
      }
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
  },
};
</script>
<!-- eslint-disable  -->
<style scoped>
::v-deep .ag-header-cell-label {
  justify-content: center !important;
  text-align: center !important;
}
</style>
